export class UserLibraryInfo {
  constructor(
    public id: string, // document ID
    public read: boolean, // 既読フラグ
    public libraryId?: string, // コンテンツID（オプション）
    public readAt?: any, // 既読日時（Firestore Timestamp）
  ) {}

  public static empty(): UserLibraryInfo {
    return new UserLibraryInfo("", false);
  }
}

// Firestore data converter
export const UserLibraryInfoConverter = {
  toFirestore: (item: any) => {
    return {
      read: item.read,
      libraryId: item.libraryId ?? null,
      readAt: item.readAt ?? null,
    };
  },
  fromFirestore: (snapshot: any, options: any) => {
    const data = snapshot.data(options);
    return new UserLibraryInfo(snapshot.id, !!data.read, data.libraryId ?? undefined, data.readAt ?? undefined);
  },
};
